<template>
  <div class="consumerWrapper">
      <div class="top">
        <search ref="consumerSearch" :buttonList='buttonList' @active='active'></search>
      </div>
      <div class="main">
        <div class="table">
          <Table ref="StudTable" :tableIndex='false' :titleList="titleList" :tableData='dataList' @callback='callback'></Table>
        </div>
        <div class="pagination">
          <Pagination v-if="isPagination" :total='total' :size='pagesize' type='1' :pageSizes='pageSizes' @handleCurrentChange='handleCurrentChange' @handleSizeChange='handleSizeChange'></Pagination> 
        </div>
      </div>
<!-- 弹框 -->
      <div class="maskBox" v-if="isMask">
        <!-- 添加绑定 -->
        <div class="addBindDialog" v-if="isOpenAddBindMask">
          <div class="top">
            <div class="topName">{{dialogInfo.title}}</div>
            <i class="el-icon-error close" @click="closeAddBind"></i>
          </div>
          <div class="filterPar">
            <div class="search">姓名：</div>
            <input class="input" type="text" placeholder="请输入家长姓名"  v-model="filterparents.name" style='outline:none;'>
            <div class="search">电话：</div>
            <input class="input" type="text" placeholder="请输入家长电话"  v-model="filterparents.telephone" style='outline:none;'>
            <div class="button" v-for="(item,i) in buttonList" :key="i" @click="active(i,filterparents)">
              <img :src="item.url" v-if="item.url">
              <div class="tip">{{item.name}}</div>
            </div>
          </div>
          <div class="parentsList">
          <Table :tableIndex='false' :isPatentsList='true' :titleList="parentsTitleList" :tableData='parentsDataList' @callback='callback'></Table>
          </div>
        </div>
        <!-- 用户详情弹框 -->
        <div class="detailinfoDialog" v-else>
          <img class="logo" src="@/assets/login/logo.png" >
          <i class="el-icon-error close" @click="cancel"></i>
          <div class="detailinfoDialogLeft">
            <el-descriptions class="margin-top" :title="dialogInfo.title" :column="3" border>
              <template slot="extra" v-if="maskType=='addOrDelBind'">
                <el-button type="primary" size="small" @click="openAddBindMask(dialogInfo.row)">添加绑定</el-button>
              </template>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  学生姓名
                </template>
                {{detailinfoList.name||''}}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i :class="detailinfoList.sex=='女'?'el-icon-female':'el-icon-male'"></i>
                  性别
                </template>
                {{detailinfoList.sex||''}}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class='el-icon-phone-outline'></i>
                  联系方式
                </template>
                {{detailinfoList.telephone||''}}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  寝室号
                </template>
                {{detailinfoList.roomNo||''}}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i :class="detailinfoList.isReturn=='否'?'el-icon-circle-close':'el-icon-circle-check'"></i>
                  是否归寝
                </template>
                <el-tag size="small" :type="detailinfoList.isReturn=='否'?'danger':''">{{detailinfoList.isReturn||''}}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i :class="detailinfoList.isPush=='否'?'el-icon-circle-close':'el-icon-circle-check'"></i>
                  是否绑定家长
                </template>
                <el-tag size="small" :type="detailinfoList.isPush=='否'?'danger':''">{{detailinfoList.isPush||''}}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-house"></i>
                  监护人信息
                </template>
                <div class="infoBox">
                  <div class="info" v-for="(item, i) in detailinfoList.parents" :key="i">
                    <div class="parName">姓名：{{item.name||''}}</div>
                    <div class="parPhone">联系方式：{{item.telephone.padEnd(11,'#')||'12345678909'}}</div>
                    <div v-if="maskType=='addOrDelBind'" class="button delButton" @click="delBind(dialogInfo.row,item,i)">
                      解除绑定
                    </div> 
                  </div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import search from '../common/search.vue'
import Pagination from'../common/Pagination.vue'
import Table from '../common/table.vue'
export default {
  components:{ search,Table,Pagination },
  data(){
    return{
      buttonList:[
        {name:'搜索',active:'searchActive'},
        {name:'刷新',active:'refreshActive',url:require('../../assets/search/refresh.png')},
        // {name:'导出Excel',active:'excelActive',url:require('../../assets/search/excel.png')}
      ],
      titleList:[
        {name:'姓名',code:'name'},
        {name:'性别',code:'sex'},
        {name:'寝室号',code:'roomNo'},
        {name:'联系方式',code:'telephone'},
        {name:'是否归寝',code:'isReturn'},
        {name:'是否绑定',code:'isPush'},
        {name:'信息',button:[{callbackText:'学生信息',active:'detailinfo',color:'#909399'}]},
        {name:'操作',button:[{callbackText:'添加/解除绑定',active:'addOrDelBind',color:'blue'}]},
      ],
      dataList:[],
      parentsTitleList:[
        {name:'姓名',code:'name'},
        {name:'联系方式',code:'telephone'},
        {name:'是否已绑定',code:'isPush'},
        {name:'操作',button:[{callbackText:'添加绑定',active:'addBind',color:'blue'}]},
      ],
      parentsDataList:[],
      total:0,
      pagesize:10,
      pageSizes:GlodbaseInfo.pageSizes,
      currentPage:1,
      // tableKey:Math.random(),
      isMask:false,
      maskType:'',
      dialogInfo:{},
      form:[],
      detailinfoList:{},
      isPagination:false,
      isChange:false,
      searchInfo:null,
      isOpenAddBindMask:false,
      filterparents:{
        name:null,
        telephone:null
      },
      addStu:null
    }
  },
  created(){
    this.titleList.forEach((e,i)=>{
      e.size = GlodbaseInfo.consumerSize[i]
    })
  },
  mounted(){
    this.pagesize=this.pageSizes[0]
    this.getData()
  },
  methods:{
    getData(){
      let par = {
        pageNo:this.currentPage,
        pageSize:this.pagesize
      }
      if (this.searchInfo) {
        this.searchInfo.name?par.stuName = this.searchInfo.name:''
        this.searchInfo.sex!='全选'?par.sex = this.searchInfo.sex=='男'?1:0:''
        this.searchInfo.isReturn!='全选'?par.isReturn = this.searchInfo.isReturn=='是'?1:0:''
        this.searchInfo.isPush!='全选'?par.isPush = this.searchInfo.isPush=='是'?1:0:''
        this.searchInfo.roomNo?par.roomNo = this.searchInfo.roomNo:''
      }
      return this.$http.post('/attendance/student/getPage',par).then(res=>{
        this.total = res.total
        this.dataList =res.records.map(e=>{
          e.sex = e.sex?'男':'女'
          e.isReturn = e.isReturn?'是':'否'
          e.isPush = e.isPush?'是':'否'
          e.pushParents=e.pushParents?e.pushParents:[]
          return e
        })
        this.isPagination = true
      })

    },
    getParents(info){
      let par = {}
      if (info) {
        info.name?par.name = info.name:''
        info.telephone?par.telephone = info.telephone:''
      }
      return this.$http.post(`/attendance/parents/getList`, par).then(res=>{
        return res.map(e=>{
          e.isPush = e.isPush?'是':'否'
          return e
        })
      })
    },
    active(e,info){
      if(!this.isOpenAddBindMask){
        this.searchInfo = info
      }
      this[this.buttonList[e].active](info)
    },
    searchActive(info){
      if(this.isOpenAddBindMask){
        this.openAddBindMask(this.addStu,info)
      }else{
        this.getData()
      }
    },
    refreshActive(){
      if(this.isOpenAddBindMask){
        this.filterparents = {
          name:null,
          telephone:null
        }
        this.openAddBindMask(this.addStu)
      }else{
        this.$refs['consumerSearch'].searchText = {
          name:null,
          sex:'全选',
          roomNo:null,
          isReturn:'全选',
          isPush:'全选'
        }
        this.searchInfo =null
        this.getData()
      }
    },
    callback(row,e){
      this[e](row)
    },
    async cancel(){
      if(this.isChange){
        await this.getData()
      }
      this.isMask =false
      this.maskType = ''
      this.dialogInfo ={}
      this.detailinfoList = {}
      this.sexName = ''
      this.isChange=false
      this.$refs['StudTable'].resizeTo()
    },
    detailinfo(row){
      this.dialogInfo = {
        title:'学生信息',
        row:row
      }
      this.detailinfoList =row
      this.detailinfoList.parents = row.pushParents
      this.maskType = 'detailinfo'
      this.isMask = true
    },
    async addOrDelBind(row){
      this.dialogInfo = {
        title:'添加/解除绑定',
        row:row
      }
      
      this.detailinfoList =row
      this.detailinfoList.parents = row.pushParents
      this.maskType = 'addOrDelBind'
      this.isMask = true
    },
    delBind(stu,parent,i){
      let par = {
        stuId:stu.id,
        isPush:0,
        parentsId:[parent.id+'']
      }
      this.$http.post('/attendance/parentAge/bind',par).then(res=>{
        // parent.isPush = parent.isPush=='是'?'否':'是'
        this.detailinfoList.parents.splice(i,1)
        this.$forceUpdate()
        this.isChange = true
        this.$message({
            showClose: true,
            message: '解除成功',
            type: 'success',
            duration: 3000
        })
      })
    },
    async openAddBindMask(row,info){
      this.dialogInfo = {
        title:'添加绑定',
        row:row
      }
      this.addStu = row
      this.parentsDataList= await this.getParents(info)
      this.isOpenAddBindMask =true
    },
    addBind(parent){
      let stu = this.addStu
      let par = {
        stuId:stu.id,
        isPush:1,
        parentsId:[parent.id+'']
      }
      this.$http.post('/attendance/parentAge/bind',par).then(res=>{
        this.openAddBindMask(this.addStu)
        this.isChange = true
        this.detailinfoList.parents.push(parent)
        this.$message({
            showClose: true,
            message: '绑定成功',
            type: 'success',
            duration: 3000
        })
      })
    },
    closeAddBind(){
      this.isOpenAddBindMask=false
      this.filterparents = {
        name:null,
        telephone:null
      }
    },
    handleCurrentChange(e){
      this.currentPage =e
      this.getData()
    },
    handleSizeChange(e){
      this.pagesize = e
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.consumerWrapper{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  .top{
    width: 100%;
    height: 6%;
    display: flex;
    justify-content: flex-start;
    background-color: #fff;
    align-items: center;
  }
  .main{
    // margin-bottom: 1.7rem;
    width: 100%;
    height: 86.3%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    .table{
      width: 100%;
      height: calc(100% - 3.5rem);
    }
    .pagination{
      margin-top: 1rem;
      height: 2rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
    }
    
  }
  .maskBox{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba($color: #000000, $alpha:0.4);
    z-index: 999;
    .addBindDialog{
      background-color: #F0F2F5;
      width: 50%;
      height: 60%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      border-radius: 0.3rem;
      .top{
        font-size: 1rem;
        font-family: Source Han Sans SC;
        font-weight: 600;
        color: #3E3A39;
        width: 100%;
        height: 13%;
        border-bottom: 1px #D9E1EC solid;
        box-sizing: border-box;
        padding: 0 0.6rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .close{
          padding-right: 0.3rem;
          font-size: 1rem;
          cursor: pointer;
        }
        .close:hover{
          font-size: 1.1rem;
        }
      }
      .filterPar{
      background-color: #F0F2F5;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 7%;
        width: calc(100% - 2rem);
        margin: 1rem;
        .search{
            font-size: 0.83rem;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #3E3A39;
            padding-left: .5rem;
        }
        .input{
            height: 70%;
            width: 8rem;
            border: 0;
            border-radius: 3px;
        }
        .input::placeholder {
            font-size: 0.5rem;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #B5B5B6;
        }
        .input::-webkit-input-placeholder {
            color: #B5B5B6;
            font-size: 0.5rem;
            font-family: Source Han Sans SC;
            font-weight: 400;
        }
        .input::-moz-placeholder {
            color: #B5B5B6;
            font-size: 0.5rem;
            font-family: Source Han Sans SC;
            font-weight: 400;
        }
        .input::-ms-input-placeholder {
            color: #B5B5B6;
            font-size: 0.5rem;
            font-family: Source Han Sans SC;
            font-weight: 400;
        }
        .button{
            border: 1px rgba(0, 0, 0, 0) solid;
            cursor: pointer;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-left: 0.83rem;
            background-color: #3399FF;
            height: 70%;
            border-radius: 3px;
            padding-left: 5px;
            padding-right: 5px;
            font-size: 0.75rem;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #FFFFFF;
            img{
                margin-right: 0.3rem;
                width: 0.7rem;
                height: 0.8rem;
            }
        }
        .button:active{
            border: 1px #000 solid;
        }
      }
      .parentsList{
        width: calc(100% - 1rem);
        height: calc(80% - 3rem);
        padding: 0 .5rem;
      }
    }
    .detailinfoDialog{
      position: relative;
      background-color: #fff;
      // width:55%;
      min-width: 600px;
      max-height: 80%;
      overflow: hidden;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-45%);
      border-radius: 0.3rem;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .logo{
        width: 2.5rem;
        height: 2.5rem;
        position: absolute;
        top: 0;
        left: .3rem;
      }
      .close{
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        padding-right: 0.3rem;
        font-size: 1rem;
        cursor: pointer;
      }
      .close:hover{
        font-size: 1.1rem;
      }
      .detailinfoDialogLeft{
        width: 100%;
        margin-top: 2.5rem;
        margin-bottom: 2rem;
        padding-left: 1rem;
        padding-right: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        font-size: 0.75rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #3E3A39;
        .infoBox{
          max-height: 10rem;
          overflow: auto;
        }
        .info{
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          margin-bottom: .3rem;
          div{
            margin-right: 3rem;
          }
          .parName{
            width: 15rem;
            white-space: normal;
          }
        }
        
      }
      
      .button{
        border: 1px rgba(0, 0, 0, 0) solid;
        cursor: pointer;
        // margin-left: 0.83rem;
        background-color: #3399FF;
        // height: 1.5rem;  
        width: 4rem;
        border-radius: 3px;
        text-align: center;
        // font-size: 0.75rem;
        // line-height: 1.5rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
      }
      .delButton{
        background-color: #aaa;
      }
      .button:active{
          border: 1px #000 solid;
      }
      // .detailinfoDialogRight{
      //   width: calc(77% - 1px);
      //   height:calc(100% - 4rem);
      //   margin-top: 2rem;
      //   margin-left: 2rem;
      //   margin-bottom: 2rem;
      //   display: flex;
      //   flex-direction: column;
      //   justify-content: flex-start;
      //   align-items: center;
      //   font-size: 0.8rem;
      //   font-family: Source Han Sans SC;
      //   font-weight: 400;
      //   color: #3E3A39;
      //   .parentsInfo{
      //     width: 100%;
      //     margin-top: 2rem;
      //     display: flex;
      //     flex-wrap: wrap;
      //     justify-content: flex-start;  
      //     .info{
      //       display: flex;
      //       flex-direction: column;
      //       justify-content: flex-start;
      //       align-items: flex-start;
      //         padding: .5rem;
      //         border: 1px #eee solid;
      //         border-radius: .5rem;
      //         margin-right: .5rem;
      //       div{
      //         margin-bottom: 1rem;
      //       }
      //     }
      //   }
      // }
    }
  }
}
</style>
<style lang='scss'>
.consumerWrapper{
  .el-calendar__header{
    display: none;
  }
  .el-calendar__body{
    height: 90%;
    padding:0;
  } 
  .el-calendar-table .el-calendar-day{
    height: 1.5rem;
    padding: 0;
  }
  .el-calendar-table thead th{
    padding: 2px 0;
  }
  .el-descriptions__body{
    height: 100%;
    overflow: auto;
  }
  .el-descriptions-item__cell{
    white-space: nowrap;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/consumer/consumer.vue